// extracted by mini-css-extract-plugin
export default {"root":"woDuK","viewport":"WVlOX","swipeable":"XzHJW","panel":"_5E1Mu","pagination":"_1sX1r"};